import { css } from "@emotion/react";
import type { EnrichedSwarovskiProductVariant } from "@swo/shared";
import type React from "react";
import { FONTS, fontSize } from "../../styles/fonts";
import { richTextListStyles } from "../../styles/rich-text";
import { CSS_COLORS } from "../../styles/styles-css-variables";
import { CSS_MQ } from "../../styles/breakpoints";
import type { TranslatedValue } from "@swo/storefront";
import { T } from "../../components/T";

export const ReviewMentionedProducts: React.FC<{
  referencedProducts: Array<{ name: string }>;
  headline: TranslatedValue;
}> = ({ referencedProducts, headline }) => {
  return (
    <div
      css={[
        css`
          color: ${CSS_COLORS.Black};
          text-align: left;

          ${CSS_MQ.atLeastMd} {
            margin-top: 20px;
          }
        `,
        fontSize.x2,
        richTextListStyles,

        FONTS.SwarovskiFutura300,
      ]}
    >
      <span
        css={[
          FONTS.SwarovskiFutura500,

          css`
            text-transform: uppercase;
            margin-bottom: 12px;
            display: block;
          `,
        ]}
      >
        <T>{headline}</T>
      </span>

      <ul
        css={[
          css`
            li + li {
              margin-top: 8px;
            }
          `,
        ]}
      >
        {referencedProducts.map(v => (
          <li key={v.name}>
            <span>{v.name}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};
